(function () {
  const VEHICLE_METAOBJECT_MAP = [
    {
      make: 'ford',
      engine: '7-3L',
      yearMin: 1999,
      yearMax: 2003,
      body: ['all','pickup'],
      handle: '1999_2003_ford_powerstroke_7_3',
    },
    {
      make: 'ford',
      engine: '6-0L',
      yearMin: 2003,
      yearMax: 2007,
      body: ['all','pickup'],
      handle: '2003_2007_ford_powerstroke_6_0',
    },
    {
      make: 'ford',
      engine: '6-4L',
      yearMin: 2008,
      yearMax: 2010,
      body: ['all','pickup'],
      handle: '2008_2010_ford_powerstroke_6_4',
    },
    {
      make: 'ford',
      engine: '6-4L',
      yearMin: 2008,
      yearMax: 2010,
      body: ['CC'],
      handle: '2008_2010_ford_powerstroke_6_4_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2011,
      yearMax: 2014,
      body: ['all','pickup'],
      handle: '2011_2014_ford_powerstroke_6_7',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2011,
      yearMax: 2014,
      body: ['CC'],
      handle: '2011_2014_ford_powerstroke_6_7_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2015,
      yearMax: 2016,
      body: ['all','pickup'],
      handle: '2015_2016_ford_powerstroke_6_7',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2015,
      yearMax: 2016,
      body: ['CC'],
      handle: '2015_2016_ford_powerstroke_6_7_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2017,
      yearMax: 2019,
      body: ['all','pickup'],
      handle: '2017_2019_ford_powerstroke_6_7',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2017,
      yearMax: 2019,
      body: ['CC'],
      handle: '2017_2019_ford_powerstroke_6_7_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2020,
      yearMax: 2022,
      body: ['all','pickup'],
      handle: '2020_2022_ford_powerstroke_6_7',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2020,
      yearMax: 2021,
      body: ['CC'],
      handle: '2020_2021_ford_powerstroke_6_7_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2022,
      yearMax: 2022,
      body: ['CC'],
      handle: '2022_ford_powerstroke_6_7_cc',
    },
    {
      make: 'ford',
      engine: '6-7L',
      yearMin: 2023,
      yearMax: 2026,
      body: ['all','pickup'],
      handle: '2023_2026_ford_powerstroke_6_7',
    },
    {
      make: 'ford',
      engine: '3-0L',
      yearMin: 2018,
      yearMax: 2020,
      body: ['all','pickup'],
      handle: '2018_2020_ford_powerstroke_3_0',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2007,
      yearMax: 2009,
      body: ['all','pickup'],
      handle: '2007_2009_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2010,
      yearMax: 2012,
      body: ['all','pickup'],
      handle: '2010_2012_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2010,
      yearMax: 2012,
      body: ['CC'],
      handle: '2010_2012_ram_cummins_6_7_cc',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2013,
      yearMax: 2017,
      body: ['all','pickup'],
      handle: '2013_2017_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2013,
      yearMax: 2017,
      body: ['CC'],
      handle: '2013_2017_ram_cummins_6_7_cc',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2018,
      yearMax: 2018,
      body: ['all','pickup'],
      handle: '2018_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2018,
      yearMax: 2018,
      body: ['CC'],
      handle: '2018_ram_cummins_6_7_cc',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2019,
      yearMax: 2020,
      body: ['all','pickup'],
      handle: '2019_2020_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2019,
      yearMax: 2020,
      body: ['CC'],
      handle: '2019_2020_ram_cummins_6_7_cc',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2021,
      yearMax: 2021,
      body: ['all','pickup'],
      handle: '2021_ram_cummins_6_7',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2021,
      yearMax: 2021,
      body: ['CC'],
      handle: '2021_ram_cummins_6_7_cc',
    },
    {
      make: 'ram',
      engine: '6-7L',
      yearMin: 2022,
      yearMax: 2024,
      body: ['all','pickup'],
      handle: '2021_2024_ram_cummins_6_7',
    },
    {
      make: 'gm',
      engine: 'LB7',
      yearMin: 2001,
      yearMax: 2004,
      body: ['all','pickup'],
      handle: '2001_2004_gm_duramax_lb7',
    },
    {
      make: 'gm',
      engine: 'LLY',
      yearMin: 2004,
      yearMax: 2005,
      body: ['all','pickup'],
      handle: '2004_2005_gm_duramax_lly',
    },
    {
      make: 'gm',
      engine: 'LBZ',
      yearMin: 2006,
      yearMax: 2007,
      body: ['all','pickup'],
      handle: '2006_2007_gm_duramax_lbz',
    },
    {
      make: 'gm',
      engine: 'LMM',
      yearMin: 2007,
      yearMax: 2010,
      body: ['all','pickup'],
      handle: '2007_2010_gm_duramax_llm',
    },
    {
      make: 'gm',
      engine: 'LML',
      yearMin: 2011,
      yearMax: 2015,
      body: ['all','pickup'],
      handle: '2011_2015_gm_duramax_lml',
      choiceSubtitle: 'Trucks with V-band clamp',
    },
    {
      make: 'gm',
      engine: 'LML',
      yearMin: 2015,
      yearMax: 2016,
      body: ['all','pickup'],
      handle: '2015_2016_gm_duramax_lml',
      yearLabel: '2015.5–2016',
      choiceSubtitle: 'Trucks with 3-bolt flange',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2017,
      yearMax: 2017,
      body: ['all','pickup'],
      handle: '2017_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2018,
      yearMax: 2018,
      body: ['all','pickup'],
      handle: '2018_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2019,
      yearMax: 2019,
      body: ['all','pickup'],
      handle: '2019_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2020,
      yearMax: 2020,
      body: ['all','pickup'],
      handle: '2020_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2021,
      yearMax: 2021,
      body: ['all','pickup'],
      handle: '2021_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2022,
      yearMax: 2022,
      body: ['all','pickup'],
      handle: '2022_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2023,
      yearMax: 2023,
      body: ['all','pickup'],
      handle: '2023_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2024,
      yearMax: 2024,
      body: ['all','pickup'],
      handle: '2024_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2025,
      yearMax: 2025,
      body: ['all','pickup'],
      handle: '2025_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'L5P',
      yearMin: 2026,
      yearMax: 2026,
      body: ['all','pickup'],
      handle: '2026_gm_duramax_l5p',
    },
    {
      make: 'gm',
      engine: 'LWN',
      yearMin: 2016,
      yearMax: 2016,
      body: ['all','pickup'],
      handle: '2016_gm_duramax_lwn',
    },
    {
      make: 'gm',
      engine: 'LWN',
      yearMin: 2017,
      yearMax: 2022,
      body: ['all','pickup'],
      handle: '2017_2022_gm_duramax_lwn',
    },
    {
      make: 'gm',
      engine: 'LM2',
      yearMin: 2020,
      yearMax: 2022,
      body: ['all','pickup'],
      handle: '2020_2022_gm_duramax_lm2',
    },
    {
      make: 'jeep',
      engine: '3-0L',
      yearMin: 2014,
      yearMax: 2017,
      body: ['all','pickup'],
      handle: '2014_2017_jeep_cherokee',
    },
    {
      make: 'ram',
      engine: '3-0L',
      yearMin: 2014,
      yearMax: 2017,
      body: ['all','pickup'],
      handle: '2014_2017_ram_ecodiesel',
    },
    {
      make: 'gm',
      engine: 'LZ0',
      yearMin: 2022,
      yearMax: 2026,
      body: ['all','pickup'],
      handle: '2022_2025_gm_duramax_lz0',
    },
  ];

  const NOTE_SUFFIX = '_note';

  // Metaobject keys → desktop/mobile state groups (order preserved)
  const STATE_GROUPS = [
    { id: 'tuner', keys: ['tuner'], mobileLabel: 'Tuner' },
    { id: 'egr', keys: ['egr'], mobileLabel: 'EGR' },
    { id: 'pipe-exhaust', keys: ['exhaust', 'down', 'up', 'man', 'muffler', 'tips'], mobileLabel: 'Pipes' },
    { id: 'intake', keys: ['intake'], mobileLabel: 'Intake' },
  ];
  const REST_STATE_ID = 'rest';
  const REST_MOBILE_LABEL = 'Extras';
  // Question order follows STATE_GROUPS key order, then remaining "extras" keys.
  const STEP_KEY_ORDER = STATE_GROUPS.flatMap((group) => group.keys);
  const KNOWN_STATE_KEYS = new Set(STEP_KEY_ORDER);

  const STEP_TITLE_OVERRIDES = {
    tuner: 'Select Your Tuner',
    egr: 'Select Your EGR',
    exhaust: 'Select Your Exhaust',
    muffler: 'Select Your Muffler',
    tips: 'Select Your Exhaust Tip',
    tip: 'Select Your Exhaust Tip',
    plug: 'Select Your Harness Plug Kit',
    ccv: 'Select Your CCV Delete Kit',
    disprev: 'Select Your Disaster Prevention Kit',
    throt: 'Select Your Throttle Valve Delete',
    down: 'Select Your Downpipe',
    up: 'Select Your Up pipe',
    intake: 'Select Your Intake',
    other: 'Related items that fit your build',
    vehicle_config: 'Confirm Your Vehicle Range',
  };

  const SKIP_OPTION_ID = '__skip__';
  const SKIP_COPY = {
    tuner: 'Skip selecting a tuner',
    egr: 'Skip selecting an EGR',
    exhaust: 'Skip exhaust selection',
    muffler: 'Skip muffler selection',
    tips: 'Skip exhaust tip selection',
    tip: 'Skip exhaust tip selection',
    plug: 'Skip harness plug kit selection',
    ccv: 'Skip CCV delete kit selection',
    disprev: 'Skip disaster prevention kit',
    throt: 'Skip throttle valve delete',
    down: 'Skip downpipe selection',
    up: 'Skip up pipe selection',
    intake: 'Skip intake selection',
  };
  const OTHER_STEP_KEY = 'other';
  const OTHER_STEP_DEFAULT_NOTE = 'Anything else you want to add that fits your truck.';
  const REQUIRED_STEP_KEYS = new Set(['vehicle_config', OTHER_STEP_KEY]);
  const SKIP_WARNING_STEP_KEYS = new Set(['tuner', 'egr', 'exhaust']);
  const SKIP_WARNING_COPY = {
    tuner: {
      message: (vehicleLabel) =>
        `By skipping a tuner selection, you will not have a complete delete kit for your ${vehicleLabel}`,
      select: 'Select a Tuner',
      skip: 'Skip ➜',
    },
    egr: {
      message: (vehicleLabel) =>
        `By skipping an EGR selection, you will not have a complete delete kit for your ${vehicleLabel}`,
      select: 'Select an EGR',
      skip: 'Skip ➜',
    },
    exhaust: {
      message: (vehicleLabel) =>
        `By skipping an exhaust selection, you will not have a complete delete kit for your ${vehicleLabel}`,
      select: 'Select an Exhaust',
      skip: 'Skip ➜',
    },
  };
  const SIZE_SOURCE_STEP_KEY = 'exhaust';
  const SIZE_FILTERED_STEP_KEYS = new Set(['muffler', 'tips', 'tip']);
  const CONFIG_CHOICE_STEP_KEY = 'vehicle_config';
  const CONFIG_CHOICE_NOTE =
    'Your year matches more than one build. Choose the range that fits your truck (for example, early vs late 2015).';
  const BUNDLE_DISCOUNT_CODE = 'CUSTOM_BUNDLE';
  const BUNDLE_DISCOUNT_PERCENT = 5;
  const BUNDLE_DISCOUNT_REQUIRED_STEPS = ['tuner', 'egr', 'exhaust'];
  const NO_DISCOUNT_TAG = 'no-discount';
  // Product tag that marks an Other-step option as "Recommended".
  const RECOMMENDED_TAG = 'bb_recommended';

  let currentSteps = [];
  let currentStepIndex = 0;
  let selectedOptionsByKey = {};
  let isBuildComplete = false;
  let pendingSkipStepKey = null;

  function getBundleRoot() {
    return document.querySelector('[id^="bundle-builder-"]');
  }

  function formatSelectedVehicleLabel(vehicle) {
    if (!vehicle?.year || !vehicle?.make || !vehicle?.engine) return 'truck';

    const year = String(vehicle.year);
    const make = String(vehicle.make).toUpperCase();
    const engine =
      window.TdVehicleStorage?.formatEngineDisplay(vehicle.engine) ||
      String(vehicle.engine).replace(/-/g, '.');

    return `${year} ${make} ${engine}`.trim();
  }

  function updateViewAllProductsCopy(vehicle) {
    const root = getBundleRoot();
    if (!root) return;

    const label = formatSelectedVehicleLabel(vehicle);
    root.querySelectorAll('[data-bundle-vehicle-label]').forEach((labelEl) => {
      labelEl.textContent = label;
    });

    const resultsUrl = window.TdVehicleStorage?.getResultsUrl(vehicle);
    if (resultsUrl) {
      document.querySelectorAll('[data-yme-results-link]').forEach((link) => {
        link.href = resultsUrl;
      });
    }
  }

  function scrollBundleIntroIntoView() {
    const intro = document.querySelector('.pre-grid-info.bundle-builder-intro');
    if (!intro) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const top = intro.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function isSkipSelection(option) {
    return Boolean(option?.skipped) || String(option?.id) === SKIP_OPTION_ID;
  }

  function isOtherStepKey(key) {
    return key === OTHER_STEP_KEY;
  }

  function isOtherStep(step) {
    return isOtherStepKey(step?.key);
  }

  function getSelectedOptionsForKey(stepKey) {
    const value = selectedOptionsByKey[stepKey];
    if (Array.isArray(value)) {
      return value.filter((option) => option && !isSkipSelection(option) && !option?.isConfigChoice);
    }
    if (!value || isSkipSelection(value) || value?.isConfigChoice) return [];
    return [value];
  }

  function isOptionSelectedForStep(stepKey, variantId) {
    return getSelectedOptionsForKey(stepKey).some((option) => String(option?.id) === String(variantId));
  }

  function ensureOtherSelection(stepKey) {
    if (!Array.isArray(selectedOptionsByKey[stepKey])) {
      selectedOptionsByKey[stepKey] = [];
    }
    return selectedOptionsByKey[stepKey];
  }

  function canSkipStep(key) {
    return Boolean(key) && !REQUIRED_STEP_KEYS.has(key);
  }

  function getSkipCopy(key) {
    if (SKIP_COPY[key]) return SKIP_COPY[key];

    const label = String(key || '')
      .replace(/[_-]+/g, ' ')
      .trim()
      .toLowerCase();

    return label ? `Skip ${label} selection` : 'Skip this selection';
  }

  function isConfigChoiceStep(step) {
    return step?.type === 'config_choice' || step?.key === CONFIG_CHOICE_STEP_KEY;
  }

  function getTempCartItems() {
    return currentSteps.flatMap((step) => {
      if (isConfigChoiceStep(step)) return [];
      return getSelectedOptionsForKey(step.key).map((option) => ({
        stepKey: step.key,
        option,
      }));
    });
  }

  function canAddBuildToCart(button = null) {
    return getTempCartItems().length > 0 && !button?.classList.contains('is-loading');
  }

  function getMetaobjectsByHandle() {
    const el = document.getElementById('td-bundle-builder-metaobjects');
    if (!el) return {};

    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (error) {
      console.warn('[Bundle Builder] Failed to parse metaobject JSON', error);
      return {};
    }
  }

  function normalizeRuleBodies(ruleBody) {
    if (Array.isArray(ruleBody)) return ruleBody.map(String);
    if (ruleBody == null || ruleBody === '') return ['all'];
    return [String(ruleBody)];
  }

  function resolveVehicleConfig({ make, year, engine, body } = {}) {
    if (!make || !year || !engine) return [];

    const y = Number(year);
    if (Number.isNaN(y)) return [];

    // Matches YMM body-style values: all | pickup | CC (Cab & Chassis / product.body)
    const selectedBody = String(body || 'all');

    // Return every overlapping range (e.g. GM LML 2015 matches both 2011–2015 and 2015–2016).
    return VEHICLE_METAOBJECT_MAP.filter((rule) => {
      if (rule.make !== make || rule.engine !== engine) return false;
      if (y < rule.yearMin || y > rule.yearMax) return false;

      // Rule body is a list of supported styles. Exact match only so CC-specific
      // maps (e.g. body: ['CC']) are not selected for pickup/all, and vice versa.
      return normalizeRuleBodies(rule.body).includes(selectedBody);
    });
  }

  function formatMapEntryLabel(entry) {
    if (!entry) return 'Vehicle build';

    const yearLabel =
      entry.yearLabel ||
      (entry.yearMin === entry.yearMax
        ? String(entry.yearMin)
        : `${entry.yearMin}–${entry.yearMax}`);
    const make = String(entry.make || '').toUpperCase();
    const engine = entry.engine || '';

    return [yearLabel, make, engine].filter(Boolean).join(' ');
  }

  function getMetaobjectData(handle) {
    if (!handle) return null;
    const metaobjects = getMetaobjectsByHandle();
    return metaobjects[handle] || null;
  }

  function isNoteFieldKey(key) {
    return typeof key === 'string' && key.endsWith(NOTE_SUFFIX);
  }

  /**
   * Groups product fields with their matching "{field}_note" text.
   * Example: tuner + tuner_note -> { key: 'tuner', note: '...', options: [...] }
   */
  function isProductStepField(field) {
    const type = field?.type;
    return (
      type === 'list.variant_reference' ||
      type === 'variant_reference' ||
      type === 'list.product_reference' ||
      type === 'product_reference'
    );
  }

  function getStepSortIndex(key) {
    if (isOtherStepKey(key)) return Number.MAX_SAFE_INTEGER;
    const knownIndex = STEP_KEY_ORDER.indexOf(key);
    if (knownIndex !== -1) return knownIndex;
    // Unknown extras (plug, ccv, etc.) come after all STATE_GROUPS keys.
    return STEP_KEY_ORDER.length;
  }

  function sortStepsByStateOrder(steps = []) {
    return [...steps].sort((a, b) => {
      const indexDiff = getStepSortIndex(a?.key) - getStepSortIndex(b?.key);
      if (indexDiff !== 0) return indexDiff;
      // Stable fallback for multiple extras outside STATE_GROUPS.
      return String(a?.key || '').localeCompare(String(b?.key || ''));
    });
  }

  function buildStepsWithNotes(fields = {}) {
    const steps = [];

    Object.entries(fields).forEach(([key, field]) => {
      if (isNoteFieldKey(key)) return;
      if (!isProductStepField(field)) return;

      const noteField = fields[`${key}${NOTE_SUFFIX}`];
      const rawOptions = field?.value;
      const options = Array.isArray(rawOptions)
        ? rawOptions
        : rawOptions
          ? [rawOptions]
          : [];

      // Empty option lists should not create a question page or sidebar state.
      if (!options.length) return;

      steps.push({
        key,
        type: field?.type || null,
        note: noteField?.value || null,
        options,
      });
    });

    return sortStepsByStateOrder(steps);
  }

  function getStateIdForKey(key) {
    if (!key) return null;

    const group = STATE_GROUPS.find((item) => item.keys.includes(key));
    if (group) return group.id;

    return REST_STATE_ID;
  }

  /**
   * Derives which sidebar state groups should be visible from metaobject step keys.
   * Known keys map to named states; any remaining key surfaces the "rest" state.
   */
  function getVisibleStateIds(steps = []) {
    const stepKeys = new Set(
      steps
        .filter((step) => !isConfigChoiceStep(step))
        .map((step) => step.key)
        .filter(Boolean)
    );
    const visible = [];

    STATE_GROUPS.forEach((group) => {
      if (group.keys.some((key) => stepKeys.has(key))) {
        visible.push(group.id);
      }
    });

    const hasRestKeys = [...stepKeys].some((key) => !KNOWN_STATE_KEYS.has(key));
    if (hasRestKeys) {
      visible.push(REST_STATE_ID);
    }

    return visible;
  }

  function logKeyToStateMapping(steps = []) {
    const keyToState = {};
    const stateToKeys = {};

    steps.forEach((step) => {
      const key = step?.key;
      if (!key) return;

      const stateId = getStateIdForKey(key);
      keyToState[key] = stateId;

      if (!stateToKeys[stateId]) stateToKeys[stateId] = [];
      stateToKeys[stateId].push(key);
    });
  }

  function getMobileStates(visibleStateIds = []) {
    const states = [{ id: 'vehicle', label: 'Vehicle' }];

    visibleStateIds.forEach((id) => {
      if (id === REST_STATE_ID) {
        states.push({ id: REST_STATE_ID, label: REST_MOBILE_LABEL });
        return;
      }

      const group = STATE_GROUPS.find((item) => item.id === id);
      if (group) states.push({ id: group.id, label: group.mobileLabel });
    });

    return states;
  }

  function getMobileLabels(visibleStateIds = []) {
    return getMobileStates(visibleStateIds).map((state) => state.label);
  }

  function getStateIdFromElement(stateEl) {
    if (stateEl.classList.contains('vehicle')) return 'vehicle';
    if (stateEl.classList.contains(REST_STATE_ID)) return REST_STATE_ID;

    const group = STATE_GROUPS.find((item) => stateEl.classList.contains(item.id));
    return group?.id || null;
  }

  function getFirstStepIndexForState(stateId) {
    if (!stateId || stateId === 'vehicle') return -1;

    return currentSteps.findIndex((step) => {
      if (isConfigChoiceStep(step)) return false;
      return getStateIdForKey(step.key) === stateId;
    });
  }

  function getActiveStateId() {
    if (!currentSteps.length) return 'vehicle';

    if (isBuildComplete) {
      const lastStep = currentSteps[currentSteps.length - 1];
      return getStateIdForKey(lastStep?.key) || 'vehicle';
    }

    const step = currentSteps[currentStepIndex];
    if (!step) return 'vehicle';
    if (isConfigChoiceStep(step)) return 'vehicle';
    return getStateIdForKey(step.key) || 'vehicle';
  }

  function canNavigateToState(stateId, activeStateId = getActiveStateId()) {
    if (!stateId) return false;

    // Vehicle is available once a step flow exists (or after build complete).
    if (stateId === 'vehicle') {
      return currentSteps.length > 0;
    }

    if (!currentSteps.length) return false;

    const targetIndex = getFirstStepIndexForState(stateId);
    if (targetIndex < 0) return false;

    if (isBuildComplete) return true;
    if (stateId === activeStateId) return true;
    if (targetIndex <= currentStepIndex) return true;

    // Allow jumping to categories already answered on a previous pass.
    return getCompletedStateIds(activeStateId).has(stateId);
  }

  function goToState(stateId) {
    const root = getBundleRoot();
    if (!root || !canNavigateToState(stateId)) return;

    if (stateId === 'vehicle') {
      isBuildComplete = false;
      showVehicleSelectionState(root);
      return;
    }

    const targetIndex = getFirstStepIndexForState(stateId);
    if (targetIndex < 0) return;

    // Jump to this category without clearing later answers. Re-selecting or
    // skipping a step still prunes from that point via select/skip handlers.
    isBuildComplete = false;
    currentStepIndex = targetIndex;
    renderCurrentStep();
  }

  function getCompletedStateIds(activeStateId = 'vehicle') {
    const completed = new Set();

    if (activeStateId !== 'vehicle' || isBuildComplete) {
      completed.add('vehicle');
    }

    if (isBuildComplete) {
      getVisibleStateIds(currentSteps).forEach((stateId) => completed.add(stateId));
      return completed;
    }

    // A multi-question category (e.g. Pipes, Finishing touches) is complete only
    // after every step in that group has been answered — not after the first one.
    const stepIndexesByState = {};
    currentSteps.forEach((step, index) => {
      if (isConfigChoiceStep(step)) return;
      const stateId = getStateIdForKey(step.key);
      if (!stateId) return;
      if (!stepIndexesByState[stateId]) stepIndexesByState[stateId] = [];
      stepIndexesByState[stateId].push(index);
    });

    Object.entries(stepIndexesByState).forEach(([stateId, indexes]) => {
      // The category currently being viewed stays active, not complete.
      if (stateId === activeStateId) return;

      const answeredByProgress = indexes.every((index) => index < currentStepIndex);
      const answeredBySelection = indexes.every(
        (index) => selectedOptionsByKey[currentSteps[index]?.key] != null
      );

      if (answeredByProgress || answeredBySelection) {
        completed.add(stateId);
      }
    });

    return completed;
  }

  function getSkippedWarningStateIds() {
    const skipped = new Set();

    currentSteps.forEach((step) => {
      if (!SKIP_WARNING_STEP_KEYS.has(step?.key)) return;
      if (!isSkipSelection(selectedOptionsByKey[step.key])) return;

      const stateId = getStateIdForKey(step.key);
      if (stateId) skipped.add(stateId);
    });

    return skipped;
  }

  function updateDesktopStates(root, visibleStateIds = [], activeStateId = 'vehicle') {
    const desktopState = root.querySelector('.desktop-state');
    if (!desktopState) return;

    const visibleSet = new Set(visibleStateIds);
    const completedSet = getCompletedStateIds(activeStateId);
    const skippedSet = getSkippedWarningStateIds();

    desktopState.querySelectorAll('.state').forEach((stateEl) => {
      const stateId = getStateIdFromElement(stateEl);
      if (!stateId) return;

      const isComplete = completedSet.has(stateId);
      const isSkipped = isComplete && skippedSet.has(stateId);

      // Vehicle is always shown; other states depend on metaobject keys.
      stateEl.hidden = stateId !== 'vehicle' && !visibleSet.has(stateId);
      stateEl.classList.toggle('active', !isBuildComplete && stateId === activeStateId);
      stateEl.classList.toggle('is-complete', isComplete);
      stateEl.classList.toggle('is-skipped', isSkipped);

      const clickable = !stateEl.hidden && canNavigateToState(stateId, activeStateId);
      stateEl.classList.toggle('is-clickable', clickable);
      stateEl.setAttribute('role', 'button');
      stateEl.tabIndex = clickable ? 0 : -1;
      stateEl.setAttribute('aria-disabled', clickable ? 'false' : 'true');
      const categoryLabel = stateEl.querySelector('.category')?.textContent?.trim() || stateId;
      stateEl.setAttribute(
        'aria-label',
        isSkipped
          ? `${categoryLabel} skipped. Go to ${categoryLabel} step`
          : `Go to ${categoryLabel} step`
      );
    });
  }

  function updateMobileStates(root, visibleStateIds = [], activeStateId = 'vehicle') {
    const mobileState = root.querySelector('.mobile-state');
    if (!mobileState) return;

    const states = getMobileStates(visibleStateIds);

    const activeLabelIndex =
      activeStateId === 'vehicle'
        ? 0
        : Math.max(
            0,
            states.findIndex((state) => state.id === activeStateId)
          );

    const barsContainer = mobileState.querySelector('.state-bars');
    if (!barsContainer) return;

    barsContainer.innerHTML = states
      .map((state, index) => {
        const activeClass = index === activeLabelIndex ? ' state-bar-active' : '';
        const clickable = canNavigateToState(state.id, activeStateId);
        const clickableClass = clickable ? ' is-clickable' : '';
        return `
          <div
            class="state-bar state-bar-${index + 1}${activeClass}${clickableClass}"
            data-state-id="${escapeHtml(state.id)}"
            role="button"
            tabindex="${clickable ? 0 : -1}"
            aria-disabled="${clickable ? 'false' : 'true'}"
            aria-label="Go to ${escapeHtml(state.label)} step"
          >${escapeHtml(state.label)}</div>
        `;
      })
      .join('');
  }

  function updateStateContainer(steps = [], activeStateId = 'vehicle') {
    const root = getBundleRoot();
    if (!root) return;

    logKeyToStateMapping(steps);

    const visibleStateIds = getVisibleStateIds(steps);
    updateDesktopStates(root, visibleStateIds, activeStateId);
    updateMobileStates(root, visibleStateIds, activeStateId);
  }

  function formatMoney(cents) {
    const amount = Number(cents);
    if (Number.isNaN(amount)) return '';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(amount / 100);
    } catch (error) {
      return `$${(amount / 100).toFixed(2)}`;
    }
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getStepTitle(key) {
    if (STEP_TITLE_OVERRIDES[key]) return STEP_TITLE_OVERRIDES[key];

    const label = String(key || '')
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

    return label ? `Select Your ${label}` : 'Select an option';
  }

  function isDefaultVariantTitle(title) {
    return !title || String(title).trim().toLowerCase() === 'default title';
  }

  // Steps where variants share one product — show variant name as the primary title.
  const VARIANT_TITLE_AS_PRIMARY_STEPS = new Set(['muffler', 'tips', 'tip']);

  /**
   * Prefer variant metafield custom.bundle_builder_title when set.
   * Otherwise: muffler / tip options share one product title, so show the
   * variant name as the primary title and hide the repeated product name.
   */
  function getOptionDisplayTitles(option, stepKey) {
    const bundleBuilderTitle = String(option?.bundle_builder_title || '').trim();
    if (bundleBuilderTitle) {
      return { title: bundleBuilderTitle, subtitle: '' };
    }

    const productTitle = option?.product_title || option?.title || 'Product';
    const variantTitle = isDefaultVariantTitle(option?.title) ? '' : option.title;

    if (VARIANT_TITLE_AS_PRIMARY_STEPS.has(stepKey) && variantTitle) {
      return { title: variantTitle, subtitle: '' };
    }

    return { title: productTitle, subtitle: variantTitle };
  }

  function getOptionSizes(option) {
    const raw = option?.bundle_builder_sizes;
    if (Array.isArray(raw)) {
      return raw.map((value) => String(value).trim()).filter(Boolean);
    }
    if (raw == null || raw === '') return [];
    return [String(raw).trim()].filter(Boolean);
  }

  function getSelectedExhaustSizes() {
    const exhaust = selectedOptionsByKey[SIZE_SOURCE_STEP_KEY];
    if (!exhaust || isSkipSelection(exhaust)) return [];
    return getOptionSizes(exhaust);
  }

  function optionMatchesExhaustSize(option, exhaustSizes) {
    if (!exhaustSizes.length) return true;

    const optionSizes = getOptionSizes(option);
    if (!optionSizes.length) return true;

    return optionSizes.some((size) => exhaustSizes.includes(size));
  }

  function getVisibleOptionsForStep(step) {
    const options = step?.options || [];
    if (!SIZE_FILTERED_STEP_KEYS.has(step?.key)) return options;
    return options.filter((option) => optionMatchesExhaustSize(option, getSelectedExhaustSizes()));
  }

  function shouldAutoSkipStep(step) {
    return SIZE_FILTERED_STEP_KEYS.has(step?.key) && getVisibleOptionsForStep(step).length === 0;
  }

  function markStepSkipped(stepKey) {
    if (!stepKey) return;
    selectedOptionsByKey[stepKey] = { id: SKIP_OPTION_ID, skipped: true };
  }

  function autoSkipIncompatibleStepsForward() {
    while (currentStepIndex < currentSteps.length && shouldAutoSkipStep(currentSteps[currentStepIndex])) {
      const step = currentSteps[currentStepIndex];
      markStepSkipped(step?.key);

      if (currentStepIndex >= currentSteps.length - 1) {
        isBuildComplete = true;
        renderBuildComplete();
        return true;
      }

      currentStepIndex += 1;
    }

    return false;
  }

  function retreatOverIncompatibleSteps() {
    while (currentStepIndex >= 0 && shouldAutoSkipStep(currentSteps[currentStepIndex])) {
      pruneSelectionsFromIndex(currentStepIndex);

      if (currentStepIndex <= 0) {
        showVehicleSelectionState();
        return true;
      }

      currentStepIndex -= 1;
    }

    return false;
  }

  function getOptionImage(option) {
    return option?.image || option?.product_image || option?.featured_image || null;
  }

  function isSoldOutOption(option) {
    // `available` covers cases the inventory fields miss (unpublished product, no inventory record).
    if (option?.available === false) return true;
    if (typeof option?.is_sold_out === 'boolean') return option.is_sold_out;

    return Boolean(option?.inventory_management) && Number(option?.inventory_quantity) <= 0;
  }

  function isBackorderOption(option) {
    if (typeof option?.is_backorder === 'boolean') return option.is_backorder;

    return isSoldOutOption(option) && option?.inventory_policy === 'continue';
  }

  function isUnavailableOption(option) {
    // Sold out with continue-selling disabled: visible, but not selectable.
    return isSoldOutOption(option) && !isBackorderOption(option);
  }

  function getSourceUrl(option) {
    const url = typeof option?.source_url === 'string' ? option.source_url.trim() : '';
    return url.length > 5 ? url : '';
  }

  function renderShipDateLine(option) {
    const url = getSourceUrl(option);
    if (!url) return '';

    return `<p class="step-option-ship-date" data-ship-date-url="${escapeHtml(url)}" hidden><span class="step-option-ship-date__label">Expected ship date:</span> <span data-ship-date-value></span></p>`;
  }

  function hydrateShipDates(root) {
    if (!root || typeof window.TDShipDate?.formatRange !== 'function') return;

    root.querySelectorAll('[data-ship-date-url]').forEach((node) => {
      const url = node.getAttribute('data-ship-date-url');
      window.TDShipDate.formatRange(url).then((range) => {
        if (!node.isConnected || !range) return;
        const value = node.querySelector('[data-ship-date-value]');
        if (value) value.textContent = range;
        node.hidden = false;
      });
    });
  }

  function renderOptionButton(option, stepKey, isSelected) {
    const { title, subtitle } = getOptionDisplayTitles(option, stepKey);
    const priceLabel = formatMoney(option?.price);
    const skuLabel = option?.sku ? `SKU: ${option.sku}` : '';
    const imageUrl = getOptionImage(option);
    const soldOut = isSoldOutOption(option);
    const backordered = isBackorderOption(option);
    const unavailable = isUnavailableOption(option);
    const soldOutOverlay = soldOut
      ? `<span class="step-option-sold-out-overlay"><span class="step-option-sold-out-label">Sold out</span></span>`
      : '';
    const imageHtml = imageUrl
      ? `<span class="step-option-image${soldOut ? ' is-sold-out' : ''}"><img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" width="72" height="72" loading="lazy">${soldOutOverlay}</span>`
      : `<span class="step-option-image step-option-image--empty${soldOut ? ' is-sold-out' : ''}" aria-hidden="true">${soldOutOverlay}</span>`;
    const backorderBadge = backordered
      ? `<span class="step-option-badge step-option-badge--backorder">Backordered</span>`
      : '';

    const addLabel = isSelected ? '✔ Added' : 'Add to build';
    const productHandle = option?.product_handle || '';
    const detailsIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" aria-hidden="true" focusable="false">
        <path d="M320 96C239.2 96 174.5 132.8 127.4 176.6C80.6 220.1 49.3 272 34.4 307.7C31.1 315.6 31.1 324.4 34.4 332.3C49.3 368 80.6 420 127.4 463.4C174.5 507.1 239.2 544 320 544C400.8 544 465.5 507.2 512.6 463.4C559.4 419.9 590.7 368 605.6 332.3C608.9 324.4 608.9 315.6 605.6 307.7C590.7 272 559.4 220 512.6 176.6C465.5 132.9 400.8 96 320 96zM176 320C176 240.5 240.5 176 320 176C399.5 176 464 240.5 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320zM320 256C320 291.3 291.3 320 256 320C244.5 320 233.7 317 224.3 311.6C223.3 322.5 224.2 333.7 227.2 344.8C240.9 396 293.6 426.4 344.8 412.7C396 399 426.4 346.3 412.7 295.1C400.5 249.4 357.2 220.3 311.6 224.3C316.9 233.6 320 244.4 320 256z"/>
      </svg>
    `;
    const detailsDisabled = productHandle ? '' : 'disabled aria-disabled="true"';
    const detailsHtml = `
      <button
        type="button"
        class="step-option-details-btn"
        data-product-handle="${escapeHtml(productHandle)}"
        data-variant-id="${escapeHtml(option?.id)}"
        ${detailsDisabled}
      >${detailsIcon}<span>View details</span></button>
    `;

    return `
      <div
        class="step-option${isSelected ? ' is-selected' : ''}${soldOut ? ' is-sold-out' : ''}${backordered ? ' is-backorder' : ''}${unavailable ? ' is-unavailable' : ''}"
        data-step-key="${escapeHtml(stepKey)}"
        data-variant-id="${escapeHtml(option?.id)}"
      >
        ${imageHtml}
        <span class="step-option-body">
          <span class="step-option-title-row">
            <p class="step-option-title">${escapeHtml(title)}</p>
            ${backorderBadge}
          </span>
          ${renderShipDateLine(option)}
          ${subtitle ? `<p class="step-option-variant">${escapeHtml(subtitle)}</p>` : ''}
          <span class="step-option-meta">
            ${priceLabel ? `<p class="step-option-price">${escapeHtml(priceLabel)}</p>` : ''}
            ${skuLabel ? `<p class="step-option-sku">${escapeHtml(skuLabel)}</p>` : ''}
          </span>
        </span>
        <div class="step-option-actions">
        ${detailsHtml}
          <button
            type="button"
            class="step-option-add-btn${isSelected ? ' is-added' : ''}"
            data-step-key="${escapeHtml(stepKey)}"
            data-variant-id="${escapeHtml(option?.id)}"
            ${unavailable ? 'disabled aria-disabled="true"' : ''}
          >${addLabel}</button>
        </div>
      </div>
    `;
  }

  function renderOtherOptionCard(option, stepKey, isSelected, isRecommended = false) {
    const { title, subtitle } = getOptionDisplayTitles(option, stepKey);
    const priceLabel = formatMoney(option?.price);
    const imageUrl = getOptionImage(option);
    const soldOut = isSoldOutOption(option);
    const backordered = isBackorderOption(option);
    const unavailable = isUnavailableOption(option);
    const soldOutOverlay = soldOut
      ? `<span class="step-option-sold-out-overlay"><span class="step-option-sold-out-label">Sold out</span></span>`
      : '';
    const imageHtml = imageUrl
      ? `<span class="other-option-image${soldOut ? ' is-sold-out' : ''}"><img src="${escapeHtml(imageUrl)}" alt="" width="160" height="88" loading="lazy">${soldOutOverlay}</span>`
      : `<span class="other-option-image other-option-image--empty${soldOut ? ' is-sold-out' : ''}" aria-hidden="true">${soldOutOverlay}</span>`;
    const backorderBadge = backordered
      ? `<span class="step-option-badge step-option-badge--backorder">Backordered</span>`
      : '';
    const productHandle = option?.product_handle || '';
    const detailsDisabled = productHandle ? '' : 'disabled aria-disabled="true"';
    const detailsHtml = `
      <button
        type="button"
        class="step-option-details-btn other-option-details-btn"
        data-product-handle="${escapeHtml(productHandle)}"
        data-variant-id="${escapeHtml(option?.id)}"
        aria-label="View details for ${escapeHtml(title)}"
        ${detailsDisabled}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
          <path d="M2.5 12S6.2 6.5 12 6.5 21.5 12 21.5 12 17.8 17.5 12 17.5 2.5 12 2.5 12z"></path>
          <circle cx="12" cy="12" r="2.4"></circle>
        </svg>
      </button>
    `;
    const checkHtml = isSelected
      ? `<span class="other-option-check is-checked" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" focusable="false">
            <circle cx="12" cy="12" r="10" fill="#2e7d32"></circle>
            <path d="M8 12.5l2.6 2.5L16.5 9.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </span>`
      : `<span class="other-option-check" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false">
            <circle cx="12" cy="12" r="9" stroke="#c8c8c8" stroke-width="1.8"></circle>
          </svg>
        </span>`;

    return `
      <div
        class="other-option${isRecommended ? ' is-recommended' : ''}${isSelected ? ' is-selected' : ''}${soldOut ? ' is-sold-out' : ''}${backordered ? ' is-backorder' : ''}${unavailable ? ' is-unavailable' : ''}"
      >
        <button
          type="button"
          class="other-option-select"
          data-step-key="${escapeHtml(stepKey)}"
          data-variant-id="${escapeHtml(option?.id)}"
          aria-pressed="${isSelected ? 'true' : 'false'}"
          ${unavailable ? 'disabled aria-disabled="true"' : ''}
        >
          ${isRecommended ? '<span class="other-option-recommended">Recommended</span>' : ''}
          ${imageHtml}
          <span class="other-option-body">
            <span class="other-option-title-row">
              <span class="other-option-title">${escapeHtml(title)}</span>
              ${backorderBadge}
            </span>
            ${renderShipDateLine(option)}
            ${subtitle ? `<span class="other-option-variant">${escapeHtml(subtitle)}</span>` : ''}
            <span class="other-option-meta">
              ${priceLabel ? `<span class="other-option-price">${escapeHtml(priceLabel)}</span>` : '<span></span>'}
              ${checkHtml}
            </span>
          </span>
        </button>
        ${detailsHtml}
      </div>
    `;
  }

  function renderOtherAddBuildFooter() {
    return `
      <div class="other-step-footer">
        <p class="other-step-footer-copy">Build your bundle and go to checkout</p>
        <button type="button" class="add-build-btn" data-other-add-build disabled aria-disabled="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
            <path d="M3 6h18"></path>
            <path d="M16 10a4 4 0 0 1-8 0"></path>
          </svg>
          <span>ADD BUILD &amp; CHECKOUT</span>
        </button>
      </div>
    `;
  }

  function renderSkipOptionButton(stepKey, isSelected) {
    const skipLabel = getSkipCopy(stepKey);

    const skipButtonLabel = isSelected ? '✔ Added' : 'Skip';

    return `
      <button
        type="button"
        class="step-option step-option--skip${isSelected ? ' is-selected' : ''}"
        data-step-key="${escapeHtml(stepKey)}"
        data-skip="true"
      >
        <span class="step-option-image step-option-image--skip" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"></path>
            <path d="M13 6l6 6-6 6"></path>
          </svg>
        </span>
        <span class="step-option-body">
          <span class="step-option-title">${escapeHtml(skipLabel)}</span>
          <span class="step-option-variant">Continue without adding this item to your build</span>
        </span>
        <span class="step-option-actions">
          <span class="step-option-add-btn${isSelected ? ' is-added' : ''}" aria-hidden="true">${skipButtonLabel}</span>
        </span>
      </button>
    `;
  }

  function renderTempCartItem(item) {
    const option = item.option;
    const { title, subtitle } = getOptionDisplayTitles(option, item.stepKey);
    const priceLabel = formatMoney(option?.price);
    const imageUrl = getOptionImage(option);
    const imageHtml = imageUrl
      ? `<div class="temp-cart-item-image"><img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" width="64" height="64" loading="lazy"></div>`
      : `<div class="temp-cart-item-image temp-cart-item-image--empty" aria-hidden="true"></div>`;

    return `
      <div class="temp-cart-item" data-step-key="${escapeHtml(item.stepKey)}">
        ${imageHtml}
        <div class="temp-cart-item-body">
          <p class="temp-cart-item-title">${escapeHtml(title)}</p>
          ${subtitle ? `<p class="temp-cart-item-variant">${escapeHtml(subtitle)}</p>` : ''}
          ${priceLabel ? `<p class="temp-cart-item-price">${escapeHtml(priceLabel)}</p>` : ''}
        </div>
      </div>
    `;
  }

  function updateAddBuildButton(root = getBundleRoot()) {
    root?.querySelectorAll('.add-build-btn').forEach((button) => {
      const canAdd = canAddBuildToCart(button);
      button.disabled = !canAdd;
      button.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
    });
  }

  function getOptionTags(option) {
    const tags = option?.product_tags || option?.tags || [];
    return Array.isArray(tags) ? tags : [];
  }

  function optionHasTag(option, tagName) {
    return getOptionTags(option).some((tag) => String(tag).trim().toLowerCase() === tagName);
  }

  function optionHasNoDiscountTag(option) {
    return optionHasTag(option, NO_DISCOUNT_TAG);
  }

  function isRecommendedOption(option) {
    return optionHasTag(option, RECOMMENDED_TAG) && !isUnavailableOption(option);
  }

  function hasSelectedProduct(stepKey) {
    return getSelectedOptionsForKey(stepKey).length > 0;
  }

  function isBundleDiscountEligible(items = getTempCartItems()) {
    const stepKeys = new Set(items.map((item) => String(item?.stepKey)));
    return BUNDLE_DISCOUNT_REQUIRED_STEPS.every((key) => stepKeys.has(String(key)));
  }

  function getBundleDiscountProgress() {
    return BUNDLE_DISCOUNT_REQUIRED_STEPS.filter((key) => hasSelectedProduct(key)).length;
  }

  function getBundleDiscountCents(items = []) {
    return items.reduce((sum, item) => {
      const option = item?.option;
      if (!option || optionHasNoDiscountTag(option)) return sum;

      const price = Number(option.price) || 0;
      return sum + Math.round((price * BUNDLE_DISCOUNT_PERCENT) / 100);
    }, 0);
  }

  function renderTempCart(root = getBundleRoot()) {
    if (!root) return;

    const list = root.querySelector('.component-cart-list');
    const countEls = root.querySelectorAll('.build-item-count');
    const subtotalEl = root.querySelector('.subtotal-price');
    const discountRow = root.querySelector('.cart-info-row--discount');
    const discountEl = root.querySelector('.discount-price');
    const discountProgressEl = root.querySelector('.discount-progress');
    const totalEl = root.querySelector('.total-price');
    const items = getTempCartItems();
    const itemCount = items.length;
    const subtotal = items.reduce((sum, item) => sum + (Number(item.option?.price) || 0), 0);
    const discount = getBundleDiscountCents(items);
    const discountEarned = isBundleDiscountEligible();
    const total = Math.max(0, subtotal - (discountEarned ? discount : 0));

    countEls.forEach((el) => {
      el.textContent = String(itemCount);
    });

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(subtotal) || '$0.00';
    }

    if (discountEl) {
      discountEl.textContent = discount ? `-${formatMoney(discount)}` : formatMoney(0) || '$0.00';
    }
    if (discountRow) {
      discountRow.hidden = !itemCount;
      discountRow.classList.toggle('is-earned', discountEarned);
    }
    if (discountProgressEl) {
      discountProgressEl.textContent = `(${getBundleDiscountProgress()}/3)`;
    }
    if (totalEl) {
      totalEl.textContent = formatMoney(total) || '$0.00';
    }

    if (!list) return;

    if (!itemCount) {
      list.classList.remove('has-items');
      list.innerHTML = `
        <div class="empty-copy">
          <p>Added products will appear here</p>
        </div>
      `;
      updateAddBuildButton(root);
      return;
    }

    list.classList.add('has-items');
    list.innerHTML = items.map((item) => renderTempCartItem(item)).join('');
    updateAddBuildButton(root);
  }

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getCartJsUrl() {
    const cartUrl = window.routes?.cart_url || '/cart';
    return `${String(cartUrl).replace(/\/$/, '')}.js`;
  }

  function getAppliedDiscountCodes(cartState) {
    if (!Array.isArray(cartState?.discount_codes)) return [];
    return cartState.discount_codes.map((item) => item?.code).filter(Boolean);
  }

  function hasBundleDiscount(codes = []) {
    return codes.some((code) => String(code).toUpperCase() === BUNDLE_DISCOUNT_CODE);
  }

  async function applyBundleDiscount(cartUi = null, items = undefined) {
    if (!isBundleDiscountEligible(items)) return null;

    try {
      const cartResponse = await fetch(getCartJsUrl(), { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) {
        throw new Error(`Cart fetch failed: ${cartResponse.status}`);
      }

      const cartState = await cartResponse.json();
      const existingCodes = getAppliedDiscountCodes(cartState);
      if (hasBundleDiscount(existingCodes)) return cartState;

      const payload = {
        discount: [...existingCodes, BUNDLE_DISCOUNT_CODE].join(','),
      };

      if (cartUi?.getSectionsToRender) {
        payload.sections = cartUi.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }

      const updateResponse = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      });
      const data = await updateResponse.json();

      if (data.status) {
        console.warn('[Bundle Builder] Discount apply failed:', data);
        return null;
      }

      return data;
    } catch (error) {
      console.warn('[Bundle Builder] Discount apply error:', error);
      return null;
    }
  }

  function getOptionProductJsonUrl(option) {
    const productPath = String(option?.url || '').split('?')[0];
    if (productPath) return `${productPath}.js`;

    const handle = option?.product_handle;
    if (!handle) return null;

    return `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`;
  }

  // Inventory in the metaobject JSON is a snapshot from page render, so re-check before adding.
  async function fetchLiveAvailability(items = []) {
    const urls = [...new Set(items.map((item) => getOptionProductJsonUrl(item.option)).filter(Boolean))];
    if (!urls.length) return {};

    const availability = {};

    await Promise.all(
      urls.map(async (url) => {
        try {
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) {
            throw new Error(`Product fetch failed: ${response.status}`);
          }

          const product = await response.json();
          (product?.variants || []).forEach((variant) => {
            availability[String(variant?.id)] = variant?.available !== false;
          });
        } catch (error) {
          // Unknown availability: let the cart API decide instead of dropping the item here.
          console.warn('[Bundle Builder] Availability check failed:', url, error);
        }
      })
    );

    return availability;
  }

  async function splitItemsByAvailability(items = []) {
    const availability = await fetchLiveAvailability(items);

    const addable = [];
    const dropped = [];

    items.forEach((item) => {
      const isLiveSoldOut = availability[String(item.option?.id)] === false;
      if (isLiveSoldOut || isUnavailableOption(item.option)) {
        dropped.push(item);
        return;
      }

      addable.push(item);
    });

    return { addable, dropped };
  }

  function buildCartLineItem(item) {
    const id = Number(item.option?.id);
    if (!id) return null;

    return {
      id,
      quantity: 1,
      properties: {
        _bundle_builder: 'true',
        _key_component: BUNDLE_DISCOUNT_REQUIRED_STEPS.includes(item.stepKey) ? 'true' : 'false',
        _build_step: String(item.stepKey || ''),
      },
    };
  }

  async function postCartAdd(lineItems, cart = null, { withSections = true } = {}) {
    // Use FormData like product-form so section HTML is returned/rendered the same way.
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    lineItems.forEach((item, index) => {
      formData.append(`items[${index}][id]`, String(item.id));
      formData.append(`items[${index}][quantity]`, String(item.quantity));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        formData.append(`items[${index}][properties][${key}]`, String(value));
      });
    });

    if (withSections && cart?.getSectionsToRender) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    config.body = formData;

    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', config);
    return response.json();
  }

  // /cart/add.js is all-or-nothing, so one sold-out variant fails the whole bundle.
  async function addItemsIndividually(items = [], cart = null) {
    const added = [];
    const dropped = [];

    for (const item of items) {
      const lineItem = buildCartLineItem(item);

      try {
        const data = await postCartAdd([lineItem], cart, { withSections: false });
        if (data.status) {
          console.warn('[Bundle Builder] Item add failed:', lineItem.id, data);
          dropped.push(item);
          continue;
        }

        added.push(item);
      } catch (error) {
        console.warn('[Bundle Builder] Item add error:', lineItem.id, error);
        dropped.push(item);
      }
    }

    return { added, dropped };
  }

  async function fetchCartWithSections(cart = null) {
    const payload = { updates: {} };

    if (cart?.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      return data.status ? null : data;
    } catch (error) {
      console.warn('[Bundle Builder] Cart section refresh failed:', error);
      return null;
    }
  }

  // Last resort when no section HTML could be rendered: the checkout button keeps the `disabled`
  // it was rendered with while the cart was empty, which locks the shopper out of checkout.
  function unstickCartCheckoutButtons() {
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach((button) => {
      button.removeAttribute('disabled');
    });
  }

  async function fetchRenderedCartSections(cart = null) {
    if (!cart?.getSectionsToRender) return null;

    const cartUrl = window.routes?.cart_url || '/cart';
    const sections = {};

    await Promise.all(
      cart.getSectionsToRender().map(async (section) => {
        try {
          const response = await fetch(`${cartUrl}?section_id=${encodeURIComponent(section.id)}`);
          if (!response.ok) {
            throw new Error(`Section fetch failed: ${response.status}`);
          }

          sections[section.id] = await response.text();
        } catch (error) {
          console.warn('[Bundle Builder] Cart section fetch failed:', section.id, error);
        }
      })
    );

    return Object.keys(sections).length ? { sections } : null;
  }

  // Same section swap as cart-drawer's renderContents, minus opening the drawer.
  function renderCartSections(cart, renderData) {
    if (!cart?.getSectionsToRender || !renderData?.sections) return;

    cart.querySelector?.('.drawer__inner')?.classList.remove('is-empty');

    cart.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !renderData.sections[section.id]) return;
      sectionElement.innerHTML = cart.getSectionInnerHTML(renderData.sections[section.id], section.selector);
    });
  }

  function getSoldOutNoticeLabels(items = []) {
    return items.map((item) => {
      const { title, subtitle } = getOptionDisplayTitles(item.option, item.stepKey);
      return subtitle ? `${title} (${subtitle})` : title;
    });
  }

  function hideCartNotice(root = getBundleRoot()) {
    const notice = root?.querySelector('[data-bundle-cart-notice]');
    if (!notice) return;

    notice.hidden = true;
  }

  function showCartNotice(droppedItems = [], addedCount = 0, root = getBundleRoot()) {
    const labels = getSoldOutNoticeLabels(droppedItems);
    const soldOutCopy =
      labels.length === 1
        ? `${labels[0]} just sold out, so it was not added.`
        : `These items just sold out, so they were not added: ${labels.join(', ')}.`;
    const followUpCopy = addedCount
      ? `The other ${addedCount === 1 ? 'item' : `${addedCount} items`} in your build ${
          addedCount === 1 ? 'is' : 'are'
        } in your cart and ready to check out.`
      : 'Nothing was added to your cart. Pick an available option to keep building.';

    const notice = root?.querySelector('[data-bundle-cart-notice]');
    if (!notice) {
      window.alert(`${soldOutCopy} ${followUpCopy}`);
      return;
    }

    const messageEl = notice.querySelector('[data-bundle-cart-notice-message]');
    if (messageEl) messageEl.textContent = `${soldOutCopy} ${followUpCopy}`;

    const cartLink = notice.querySelector('[data-bundle-cart-notice-link]');
    if (cartLink) cartLink.hidden = !addedCount;

    notice.hidden = false;
    notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function cartAddFailure(droppedItems = []) {
    return { ok: false, addedItems: [], droppedItems, discountApplied: false };
  }

  async function addBuildToCart(root = getBundleRoot(), { redirectToCheckout = false } = {}) {
    const buttons = [...(root?.querySelectorAll('.add-build-btn') || [])];
    const items = getTempCartItems();

    if (!canAddBuildToCart(buttons[0]) || !items.length) return cartAddFailure();

    hideCartNotice(root);

    const cart = getCartUi();
    const labels = buttons.map((button) => button.querySelector('span:last-child'));
    const originalLabels = labels.map((label) => label?.textContent);

    buttons.forEach((button) => {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
    labels.forEach((label) => {
      if (label) label.textContent = 'ADDING...';
    });

    try {
      const { addable, dropped } = await splitItemsByAvailability(items);

      const addableItems = [];
      const lineItems = [];
      addable.forEach((item) => {
        const lineItem = buildCartLineItem(item);
        if (!lineItem) {
          console.warn('[Bundle Builder] Skipping build item without a valid variant ID:', item);
          return;
        }

        addableItems.push(item);
        lineItems.push(lineItem);
      });

      if (!addableItems.length) {
        if (dropped.length) showCartNotice(dropped, 0, root);
        else console.warn('[Bundle Builder] No valid variant IDs to add to cart');

        return cartAddFailure(dropped);
      }

      cart?.setActiveElement?.(document.activeElement);

      let addedItems = addableItems;
      let droppedItems = dropped;
      let data = await postCartAdd(lineItems, cart);

      if (data.status) {
        // Inventory can change between the availability check and the add, so salvage what is left.
        console.warn('[Bundle Builder] Bulk cart add failed, retrying item by item:', data);

        const retry = await addItemsIndividually(addableItems, cart);
        addedItems = retry.added;
        droppedItems = [...dropped, ...retry.dropped];

        if (!addedItems.length) {
          showCartNotice(droppedItems, 0, root);
          return cartAddFailure(droppedItems);
        }

        data = (await fetchCartWithSections(cart)) || {};
      }

      const hasDropped = droppedItems.length > 0;
      const discountedCart = await applyBundleDiscount(cart, addedItems);
      let renderData = discountedCart?.sections ? discountedCart : data;

      if (!renderData?.sections) {
        renderData = (await fetchRenderedCartSections(cart)) || renderData;
      }

      if (data.items && data.key === undefined) {
        data.key = data.items[0]?.key;
        data.id = data.items[0]?.id;
      }
      if (renderData && data.key != null) renderData.key = data.key;
      if (renderData && data.id != null) renderData.id = data.id;

      if (cart) {
        // Match product-form: clear the empty-cart UI state before opening the drawer.
        // Without this, cart-drawer keeps `is-empty` and continues showing the empty warnings
        // even though line items were added successfully.
        if (cart.classList?.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bundle-builder',
          cartData: renderData,
        });
      }

      if (cart && (hasDropped || !redirectToCheckout)) {
        // Keep the drawer closed on a partial add so the sold-out notice is seen first.
        // renderContents throws without section HTML, so fall back to the quiet swap.
        if (hasDropped || !renderData?.sections) renderCartSections(cart, renderData);
        else cart.renderContents(renderData);
      }

      unstickCartCheckoutButtons();

      // Build has been moved into the real cart.
      selectedOptionsByKey = {};
      renderTempCart(root);
      if (isOtherStep(currentSteps[currentStepIndex])) {
        renderCurrentStep();
      }

      if (hasDropped) {
        showCartNotice(droppedItems, addedItems.length, root);
      } else if (redirectToCheckout) {
        window.location.href = '/checkout';
      } else if (!cart) {
        window.location = window.routes?.cart_url || '/cart';
      }

      return {
        ok: true,
        addedItems,
        droppedItems,
        discountApplied: Boolean(discountedCart),
      };
    } catch (error) {
      console.error('[Bundle Builder] Cart add error:', error);
      window.alert('Unable to add build to cart. Please try again.');
      return cartAddFailure();
    } finally {
      buttons.forEach((button) => {
        button.classList.remove('is-loading');
      });
      labels.forEach((label, index) => {
        if (label && originalLabels[index]) label.textContent = originalLabels[index];
      });
      updateAddBuildButton(root);
    }
  }

  function pruneSelectionsFromIndex(fromIndex) {
    currentSteps.forEach((step, index) => {
      if (index >= fromIndex) {
        delete selectedOptionsByKey[step.key];
      }
    });
    renderTempCart();
  }

  function clearTempCart() {
    selectedOptionsByKey = {};
    isBuildComplete = false;
    pendingSkipStepKey = null;
    closeSkipWarningModal();
    hideCartNotice();
    renderTempCart();

    if (currentSteps.length) {
      currentStepIndex = 0;
      renderCurrentStep();
    }
  }

  function showVehicleSelectionState(root = getBundleRoot()) {
    const vehicleQuestion = root?.querySelector('.question-container-vehicle');
    const stepQuestion = root?.querySelector('.question-container-step');

    if (stepQuestion) {
      stepQuestion.hidden = true;
      stepQuestion.innerHTML = '';
    }

    if (vehicleQuestion) {
      vehicleQuestion.hidden = false;
      vehicleQuestion.classList.remove('is-no-bundle');
    }

    isBuildComplete = false;
    currentStepIndex = 0;
    updateStateContainer(currentSteps, 'vehicle');
    updateAddBuildButton(root);
  }

  function goToPreviousSelection() {
    if (isBuildComplete) {
      // Return to the last question with its selection still intact in the temp cart.
      isBuildComplete = false;
      currentStepIndex = Math.max(currentSteps.length - 1, 0);
      if (retreatOverIncompatibleSteps()) return;
      renderCurrentStep();
      return;
    }

    if (currentStepIndex <= 0) {
      pruneSelectionsFromIndex(0);
      showVehicleSelectionState();
      return;
    }

    // Leaving a question removes that step (and later ones) from the temp cart.
    pruneSelectionsFromIndex(currentStepIndex);
    currentStepIndex -= 1;
    if (retreatOverIncompatibleSteps()) return;
    renderCurrentStep();
  }

  function goToNextStep() {
    if (currentStepIndex < currentSteps.length - 1) {
      currentStepIndex += 1;
      isBuildComplete = false;
      if (autoSkipIncompatibleStepsForward()) return;
      renderCurrentStep();
      return;
    }

    isBuildComplete = true;
    renderBuildComplete();
  }

  function renderBuildComplete() {
    const root = getBundleRoot();
    if (!root) return;

    const vehicleQuestion = root.querySelector('.question-container-vehicle');
    const stepQuestion = root.querySelector('.question-container-step');
    if (!stepQuestion) return;

    if (vehicleQuestion) vehicleQuestion.hidden = true;
    stepQuestion.hidden = false;
    stepQuestion.innerHTML = `
      <button type="button" class="step-back-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M15 18l-6-6 6-6"></path>
        </svg>
        <span>Back</span>
      </button>
      <h2 class="question-title">Build complete</h2>
      <p class="question-desc">
        <span class="build-complete-copy build-complete-copy--desktop">Review your build on the right, then add it to your cart when you're ready.</span>
        <span class="build-complete-copy build-complete-copy--mobile">Review your build below, then add it to your cart when you're ready.</span>
      </p>
    `;

    const lastStep = currentSteps[currentSteps.length - 1];
    const activeStateId = getStateIdForKey(lastStep?.key) || 'vehicle';
    updateStateContainer(currentSteps, activeStateId);
    updateAddBuildButton(root);
  }

  function renderCurrentStep() {
    const root = getBundleRoot();
    if (!root) return;

    const vehicleQuestion = root.querySelector('.question-container-vehicle');
    const stepQuestion = root.querySelector('.question-container-step');
    if (!stepQuestion) return;

    if (isBuildComplete) {
      renderBuildComplete();
      return;
    }

    const step = currentSteps[currentStepIndex];
    if (!step) {
      showVehicleSelectionState(root);
      return;
    }

    if (vehicleQuestion) vehicleQuestion.hidden = true;
    stepQuestion.hidden = false;

    if (isOtherStep(step)) {
      ensureOtherSelection(step.key);
    }

    const selectedOption = selectedOptionsByKey[step.key];
    const selectedVariantId = Array.isArray(selectedOption) ? null : selectedOption?.id;
    const skipSelected = !isOtherStep(step) && isSkipSelection(selectedOption);
    const isOther = isOtherStep(step);
    const optionsHtml = getVisibleOptionsForStep(step)
      .map((option) =>
        isOther
          ? renderOtherOptionCard(
              option,
              step.key,
              isOptionSelectedForStep(step.key, option?.id),
              isRecommendedOption(option)
            )
          : renderOptionButton(
              option,
              step.key,
              !skipSelected && String(option?.id) === String(selectedVariantId)
            )
      )
      .join('');
    const canSkip = canSkipStep(step.key);
    const skipHtml = canSkip ? renderSkipOptionButton(step.key, skipSelected) : '';
    const skipNavHtml = canSkip
      ? `
        <button type="button" class="step-skip-btn" data-step-key="${escapeHtml(step.key)}">
          <span>Skip</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M9 18l6-6-6-6"></path>
          </svg>
        </button>
      `
      : '';
    const stepNote = isOther ? step.note || OTHER_STEP_DEFAULT_NOTE : step.note;
    const optionsClass = isOther ? 'step-options step-options--other' : 'step-options';
    const optionsRole = isOther ? 'group' : 'listbox';
    const footerHtml = isOther ? renderOtherAddBuildFooter() : '';

    stepQuestion.innerHTML = `
      <div class="step-nav">
        <button type="button" class="step-back-btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
          <span>Back</span>
        </button>
        ${skipNavHtml}
      </div>
      <h2 class="question-title">${escapeHtml(getStepTitle(step.key))}</h2>
      ${stepNote ? `<p class="question-desc">${escapeHtml(stepNote)}</p>` : ''}
      <div class="${optionsClass}" role="${optionsRole}" aria-label="${escapeHtml(getStepTitle(step.key))}">
        ${optionsHtml}
        ${skipHtml}
      </div>
      ${footerHtml}
    `;

    const activeStateId = isConfigChoiceStep(step) ? 'vehicle' : getStateIdForKey(step.key) || 'vehicle';
    updateStateContainer(currentSteps, activeStateId);
    updateAddBuildButton(root);
    hydrateShipDates(stepQuestion);
  }

  function selectStepOption(stepKey, variantId) {
    const stepIndex = currentSteps.findIndex((item) => item.key === stepKey);
    const step = currentSteps[stepIndex];
    if (!step || stepIndex !== currentStepIndex) return;

    const option = getVisibleOptionsForStep(step).find((item) => String(item?.id) === String(variantId));
    if (!option || isUnavailableOption(option)) return;

    const previousOption = selectedOptionsByKey[stepKey];
    const selectionChanged =
      !previousOption ||
      isSkipSelection(previousOption) ||
      String(previousOption.id) !== String(option.id);

    // Only clear later choices when this answer actually changes.
    if (selectionChanged) {
      pruneSelectionsFromIndex(stepIndex);
      selectedOptionsByKey[stepKey] = option;
    }

    // Mid-year / overlapping map entries: swap in the chosen metaobject's product steps.
    if (isConfigChoiceStep(step) && option.isConfigChoice) {
      const nextSteps = Array.isArray(option.steps) ? option.steps : [];
      currentSteps = [step, ...nextSteps];
      currentStepIndex = 0;
      isBuildComplete = false;

      if (!nextSteps.length) {
        showNoBundleState();
        return;
      }

      goToNextStep();
      return;
    }

    renderTempCart();
    goToNextStep();
  }

  function toggleOtherOption(stepKey, variantId) {
    if (!isOtherStepKey(stepKey)) return;

    const stepIndex = currentSteps.findIndex((item) => item.key === stepKey);
    const step = currentSteps[stepIndex];
    if (!step || stepIndex !== currentStepIndex) return;

    const option = getVisibleOptionsForStep(step).find((item) => String(item?.id) === String(variantId));
    if (!option || isUnavailableOption(option)) return;

    const selected = ensureOtherSelection(stepKey);
    const existingIndex = selected.findIndex((item) => String(item?.id) === String(variantId));

    if (existingIndex >= 0) {
      selected.splice(existingIndex, 1);
    } else {
      selected.push(option);
    }

    selectedOptionsByKey[stepKey] = selected;
    renderTempCart();
    renderCurrentStep();

    const focusTarget = getBundleRoot()?.querySelector(
      `.other-option-select[data-variant-id="${CSS.escape(String(variantId))}"]`
    );
    focusTarget?.focus({ preventScroll: true });
  }

  function requestSkipStep(stepKey) {
    if (!canSkipStep(stepKey)) return;

    if (SKIP_WARNING_STEP_KEYS.has(stepKey)) {
      pendingSkipStepKey = stepKey;
      openSkipWarningModal();
      return;
    }

    skipStep(stepKey);
  }

  function skipStep(stepKey) {
    const stepIndex = currentSteps.findIndex((item) => item.key === stepKey);
    const step = currentSteps[stepIndex];
    if (!step || stepIndex !== currentStepIndex || !canSkipStep(stepKey)) return;

    const previousOption = selectedOptionsByKey[stepKey];
    const selectionChanged = !isSkipSelection(previousOption);

    if (selectionChanged) {
      pruneSelectionsFromIndex(stepIndex);
      selectedOptionsByKey[stepKey] = { id: SKIP_OPTION_ID, skipped: true };
      renderTempCart();
    }

    goToNextStep();
  }

  function getSkipWarningModal(root = getBundleRoot()) {
    return root?.querySelector('[data-bundle-skip-warning]') || null;
  }

  function closeSkipWarningModal(root = getBundleRoot()) {
    const modal = getSkipWarningModal(root);
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('bundle-skip-warning-open');
  }

  function updateSkipWarningCopy(modal, stepKey) {
    if (!modal) return;

    const copy = SKIP_WARNING_COPY[stepKey];
    if (!copy) return;

    const vehicleLabel = formatSelectedVehicleLabel(window.TdVehicleStorage?.getSelectedVehicle());
    const messageEl = modal.querySelector('.bundle-skip-warning__message');
    const selectEl = modal.querySelector('.bundle-skip-warning__select');
    const skipEl = modal.querySelector('.bundle-skip-warning__skip');

    if (messageEl) messageEl.textContent = copy.message(vehicleLabel);
    if (selectEl) selectEl.textContent = copy.select;
    if (skipEl) skipEl.textContent = copy.skip;
  }

  function openSkipWarningModal(root = getBundleRoot()) {
    const modal = getSkipWarningModal(root);
    if (!modal) return;

    updateSkipWarningCopy(modal, pendingSkipStepKey);
    closeProductDetailsModal(root);
    modal.hidden = false;
    document.body.classList.add('bundle-skip-warning-open');
    modal.querySelector('.bundle-skip-warning__dialog')?.focus();
  }

  function cancelPendingSkip(root = getBundleRoot()) {
    pendingSkipStepKey = null;
    closeSkipWarningModal(root);
  }

  function confirmPendingSkip(root = getBundleRoot()) {
    const stepKey = pendingSkipStepKey;
    pendingSkipStepKey = null;
    closeSkipWarningModal(root);
    if (stepKey) {
      skipStep(stepKey);
      scrollBundleIntroIntoView();
    }
  }

  function getDetailsModal(root = getBundleRoot()) {
    return root?.querySelector('[data-bundle-details-modal]') || null;
  }

  function closeProductDetailsModal(root = getBundleRoot()) {
    const modal = getDetailsModal(root);
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.body.classList.remove('bundle-details-modal-open');
  }

  function setDetailsModalContent(root, html) {
    const content = getDetailsModal(root)?.querySelector('[data-bundle-details-content]');
    if (content) content.innerHTML = html;
  }

  async function openProductDetailsModal(root, { handle, variantId } = {}) {
    const modal = getDetailsModal(root);
    if (!modal || !handle) return;

    modal.hidden = false;
    document.body.classList.add('bundle-details-modal-open');
    setDetailsModalContent(root, `<p class="bundle-details-modal__status">Loading product details…</p>`);
    modal.querySelector('.bundle-details-modal__dialog')?.focus();

    const params = new URLSearchParams({ view: 'bundle-details' });
    if (variantId) params.set('variant', String(variantId));

    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}?${params.toString()}`);
      if (!response.ok) throw new Error(`Details request failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const details = doc.querySelector('[data-bundle-product-details]');
      if (!details) throw new Error('Details markup missing');

      const title = details.querySelector('.bundle-product-details__title');
      if (title && !title.id) title.id = 'BundleDetailsTitle';

      setDetailsModalContent(root, details.outerHTML);
    } catch (error) {
      console.warn('[Bundle Builder] Failed to load product details', error);
      setDetailsModalContent(
        root,
        `<p class="bundle-details-modal__status">Unable to load product details. Please try again.</p>`
      );
    }
  }

  function bindStepClicks(root) {
    root?.addEventListener('click', (event) => {
      const clearAllButton = event.target.closest('.clear-all-btn');
      if (clearAllButton && root.contains(clearAllButton)) {
        clearTempCart();
        return;
      }

      const otherAddBuildButton = event.target.closest('[data-other-add-build]');
      if (otherAddBuildButton && root.contains(otherAddBuildButton)) {
        addBuildToCart(root, { redirectToCheckout: true });
        return;
      }

      const addBuildButton = event.target.closest('.add-build-btn');
      if (addBuildButton && root.contains(addBuildButton)) {
        addBuildToCart(root);
        return;
      }

      const noticeDismissButton = event.target.closest('[data-bundle-cart-notice-dismiss]');
      if (noticeDismissButton && root.contains(noticeDismissButton)) {
        hideCartNotice(root);
        return;
      }

      const stateButton = event.target.closest('.desktop-state .state');
      if (stateButton && root.contains(stateButton)) {
        const stateId = getStateIdFromElement(stateButton);
        if (stateId) goToState(stateId);
        return;
      }

      const mobileStateButton = event.target.closest('.mobile-state .state-bar');
      if (mobileStateButton && root.contains(mobileStateButton)) {
        const stateId = mobileStateButton.dataset.stateId;
        if (stateId) goToState(stateId);
        return;
      }

      const backButton = event.target.closest('.step-back-btn');
      if (backButton && root.contains(backButton)) {
        goToPreviousSelection();
        return;
      }

      const skipNavButton = event.target.closest('.step-skip-btn');
      if (skipNavButton && root.contains(skipNavButton)) {
        const stepKey = skipNavButton.dataset.stepKey;
        if (stepKey) requestSkipStep(stepKey);
        return;
      }

      const skipWarning = event.target.closest('[data-bundle-skip-warning]');
      if (skipWarning && root.contains(skipWarning)) {
        if (event.target.closest('[data-bundle-skip-warning-confirm]')) {
          confirmPendingSkip(root);
          return;
        }
        if (
          event.target.hasAttribute('data-bundle-skip-warning-cancel') ||
          event.target.closest('[data-bundle-skip-warning-cancel]') ||
          !event.target.closest('.bundle-skip-warning__dialog')
        ) {
          cancelPendingSkip(root);
        }
        return;
      }

      const galleryThumb = event.target.closest('[data-bundle-gallery-thumb]');
      if (galleryThumb && root.contains(galleryThumb)) {
        const gallery = galleryThumb.closest('[data-bundle-product-details]');
        const mainImage = gallery?.querySelector('[data-bundle-gallery-main]');
        if (mainImage && galleryThumb.dataset.imageSrc) {
          mainImage.src = galleryThumb.dataset.imageSrc;
          if (galleryThumb.dataset.imageAlt) mainImage.alt = galleryThumb.dataset.imageAlt;
          gallery.querySelectorAll('[data-bundle-gallery-thumb]').forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb === galleryThumb);
          });
        }
        return;
      }

      const detailsModal = event.target.closest('[data-bundle-details-modal]');
      if (detailsModal && root.contains(detailsModal)) {
        if (
          event.target.hasAttribute('data-bundle-details-close') ||
          event.target.closest('[data-bundle-details-close]') ||
          !event.target.closest('.bundle-details-modal__dialog')
        ) {
          closeProductDetailsModal(root);
        }
        return;
      }

      const detailsButton = event.target.closest('.step-option-details-btn');
      if (detailsButton && root.contains(detailsButton)) {
        if (detailsButton.disabled || detailsButton.getAttribute('aria-disabled') === 'true') return;
        openProductDetailsModal(root, {
          handle: detailsButton.dataset.productHandle,
          variantId: detailsButton.dataset.variantId,
        });
        return;
      }

      const otherSelect = event.target.closest('.other-option-select');
      if (otherSelect && root.contains(otherSelect)) {
        if (otherSelect.disabled || otherSelect.getAttribute('aria-disabled') === 'true') return;
        const stepKey = otherSelect.dataset.stepKey;
        const variantId = otherSelect.dataset.variantId;
        if (stepKey && variantId) toggleOtherOption(stepKey, variantId);
        return;
      }

      const skipOption = event.target.closest('.step-option--skip');
      if (skipOption && root.contains(skipOption)) {
        const stepKey = skipOption.dataset.stepKey;
        if (!stepKey) return;

        requestSkipStep(stepKey);
        if (!SKIP_WARNING_STEP_KEYS.has(stepKey)) {
          scrollBundleIntroIntoView();
        }
        return;
      }

      const optionButton = event.target.closest('.step-option-add-btn');
      if (!optionButton || !root.contains(optionButton)) return;
      if (optionButton.disabled || optionButton.getAttribute('aria-disabled') === 'true') return;

      const stepKey = optionButton.dataset.stepKey;
      if (!stepKey) return;

      const variantId = optionButton.dataset.variantId;
      if (!variantId) return;

      selectStepOption(stepKey, variantId);
      scrollBundleIntroIntoView();
    });

    root?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const skipWarningModal = getSkipWarningModal(root);
        if (skipWarningModal && !skipWarningModal.hidden) {
          cancelPendingSkip(root);
          return;
        }
        closeProductDetailsModal(root);
        return;
      }

      if (event.key !== 'Enter' && event.key !== ' ') return;

      const desktopStateButton = event.target.closest('.desktop-state .state');
      if (desktopStateButton && root.contains(desktopStateButton)) {
        event.preventDefault();
        const stateId = getStateIdFromElement(desktopStateButton);
        if (stateId) goToState(stateId);
        return;
      }

      const mobileStateButton = event.target.closest('.mobile-state .state-bar');
      if (mobileStateButton && root.contains(mobileStateButton)) {
        event.preventDefault();
        const stateId = mobileStateButton.dataset.stateId;
        if (stateId) goToState(stateId);
      }
    });
  }

  function startBundleSteps(steps = []) {
    currentSteps = Array.isArray(steps) ? steps : [];
    currentStepIndex = 0;
    selectedOptionsByKey = {};
    isBuildComplete = false;
    pendingSkipStepKey = null;
    closeSkipWarningModal();

    if (!currentSteps.length) {
      showNoBundleState();
      return;
    }

    const root = getBundleRoot();
    const vehicleQuestion = root?.querySelector('.question-container-vehicle');
    if (vehicleQuestion) {
      vehicleQuestion.classList.remove('is-no-bundle');
      vehicleQuestion.hidden = true;
    }

    renderTempCart(root);
    renderCurrentStep();
  }

  function showNoBundleState(root = getBundleRoot()) {
    const vehicleQuestion = root?.querySelector('.question-container-vehicle');
    const stepQuestion = root?.querySelector('.question-container-step');

    currentSteps = [];
    currentStepIndex = 0;
    selectedOptionsByKey = {};
    isBuildComplete = false;
    pendingSkipStepKey = null;
    closeSkipWarningModal(root);

    if (stepQuestion) {
      stepQuestion.hidden = true;
      stepQuestion.innerHTML = '';
    }

    if (vehicleQuestion) {
      vehicleQuestion.hidden = false;
      vehicleQuestion.classList.add('is-no-bundle');
    }

    renderTempCart(root);
    updateStateContainer([], 'vehicle');
  }

  function buildAvailableVehicleConfigs(matches = []) {
    return matches
      .map((mapEntry) => {
        const metaobject = getMetaobjectData(mapEntry.handle);
        if (!metaobject || metaobject.error) return null;

        const steps = buildStepsWithNotes(metaobject.fields);
        if (!steps.length) return null;

        return { mapEntry, metaobject, steps };
      })
      .filter(Boolean);
  }

  function startFromVehicleConfigs(available = []) {
    if (!available.length) {
      showNoBundleState();
      return null;
    }

    if (available.length === 1) {
      const only = available[0];
      startBundleSteps(only.steps);
      return only;
    }

    const configStep = {
      key: CONFIG_CHOICE_STEP_KEY,
      type: 'config_choice',
      note: CONFIG_CHOICE_NOTE,
      options: available.map((item) => ({
        id: item.mapEntry.handle,
        product_title: formatMapEntryLabel(item.mapEntry),
        title: item.mapEntry.choiceSubtitle || 'Tap to build with this year range',
        isConfigChoice: true,
        mapEntry: item.mapEntry,
        metaobject: item.metaobject,
        steps: item.steps,
      })),
    };

    startBundleSteps([configStep]);

    return {
      mapEntries: available.map((item) => item.mapEntry),
      metaobjects: available.map((item) => item.metaobject),
      steps: [configStep],
    };
  }

  function applySelectedVehicle(vehicle) {
    updateViewAllProductsCopy(vehicle);

    const root = getBundleRoot();
    const matches = resolveVehicleConfig({
      make: vehicle?.make,
      year: vehicle?.year,
      engine: vehicle?.engine,
      body: vehicle?.body,
    });

    if (!matches.length) {
      showNoBundleState(root);
      return null;
    }

    const available = buildAvailableVehicleConfigs(matches);
    if (!available.length) {
      showNoBundleState(root);
      return {
        mapEntries: matches,
        metaobject: null,
        steps: [],
      };
    }

    return startFromVehicleConfigs(available);
  }

  function initBundleBuilder() {
    const root = getBundleRoot();
    bindStepClicks(root);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeProductDetailsModal(root);
    });

    document.addEventListener('click', (event) => {
      const modal = getDetailsModal(root);
      if (!modal || modal.hidden) return;
      if (event.target.closest('.step-option-details-btn')) return;
      if (event.target.closest('.bundle-details-modal__dialog')) return;
      closeProductDetailsModal(root);
    });

    window.addEventListener('td:vehicle-set', (event) => {
      applySelectedVehicle(event.detail);
    });

    window.addEventListener('td:vehicle-storage-change', () => {
      const selectedVehicle = window.TdVehicleStorage?.getSelectedVehicle();
      if (selectedVehicle) {
        applySelectedVehicle(selectedVehicle);
        return;
      }

      updateViewAllProductsCopy(null);
    });

    const selectedVehicle = window.TdVehicleStorage?.getSelectedVehicle();
    if (selectedVehicle) {
      applySelectedVehicle(selectedVehicle);
    } else {
      updateViewAllProductsCopy(null);
    }
  }

  function serializeOption(option, stepKey) {
    const { title, subtitle } = getOptionDisplayTitles(option, stepKey);
    return {
      id: String(option?.id ?? ''),
      title,
      subtitle: subtitle || '',
      sku: option?.sku || null,
      price: Number(option?.price) || 0,
      priceLabel: formatMoney(option?.price) || null,
      url: option?.url || null,
      available: option?.available !== false,
      soldOut: isSoldOutOption(option),
      backorder: isBackorderOption(option),
      unavailable: isUnavailableOption(option),
      isConfigChoice: Boolean(option?.isConfigChoice),
      selected: isOptionSelectedForStep(stepKey, option?.id),
      recommended: isOtherStepKey(stepKey) && isRecommendedOption(option),
    };
  }

  function serializeBuildItems(items = getTempCartItems()) {
    return items.map((item) => {
      const { title, subtitle } = getOptionDisplayTitles(item.option, item.stepKey);
      return {
        stepKey: item.stepKey,
        id: String(item.option?.id ?? ''),
        title,
        subtitle: subtitle || '',
        sku: item.option?.sku || null,
        price: Number(item.option?.price) || 0,
        priceLabel: formatMoney(item.option?.price) || null,
      };
    });
  }

  function getBundlePhase() {
    const vehicle = window.TdVehicleStorage?.getSelectedVehicle();
    if (!vehicle?.make) return 'needs_vehicle';
    if (!currentSteps.length) return 'no_bundle';
    if (isBuildComplete) return 'complete';
    if (isConfigChoiceStep(currentSteps[currentStepIndex])) return 'vehicle_config';
    return 'step';
  }

  function getState() {
    const vehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;
    const step = currentSteps[currentStepIndex] || null;
    const items = getTempCartItems();
    const skipWarningCopy = step && SKIP_WARNING_COPY[step.key] ? SKIP_WARNING_COPY[step.key] : null;
    const missingDiscountSteps = BUNDLE_DISCOUNT_REQUIRED_STEPS.filter((key) => !hasSelectedProduct(key));

    return {
      vehicle: vehicle
        ? {
            year: vehicle.year,
            make: vehicle.make,
            engine: vehicle.engine,
            body: vehicle.body || 'all',
            label: formatSelectedVehicleLabel(vehicle),
          }
        : null,
      hasBundle: currentSteps.length > 0,
      isBuildComplete,
      phase: getBundlePhase(),
      currentStep: step
        ? {
            key: step.key,
            title: getStepTitle(step.key),
            note: isOtherStep(step)
              ? step.note || OTHER_STEP_DEFAULT_NOTE
              : step.note || (isConfigChoiceStep(step) ? CONFIG_CHOICE_NOTE : null),
            canSkip: canSkipStep(step.key),
            multiSelect: isOtherStep(step),
            skipWarning: skipWarningCopy ? skipWarningCopy.message(formatSelectedVehicleLabel(vehicle)) : null,
            options: getVisibleOptionsForStep(step).map((option) => serializeOption(option, step.key)),
          }
        : null,
      build: {
        items: serializeBuildItems(items),
        discountEligible: isBundleDiscountEligible(),
        discountPercent: BUNDLE_DISCOUNT_PERCENT,
        discountCode: BUNDLE_DISCOUNT_CODE,
        discountProgress: {
          have: getBundleDiscountProgress(),
          need: missingDiscountSteps,
        },
        canAddToCart: canAddBuildToCart(),
      },
    };
  }

  function chooseOption(stepKey, optionId) {
    const state = getState();
    if (state.phase === 'needs_vehicle') {
      return { error: 'No vehicle selected. Use set_shopper_vehicle first.', state };
    }
    if (state.phase === 'no_bundle') {
      return { error: 'No custom kit is available for this vehicle.', state };
    }
    if (state.isBuildComplete) {
      return {
        error: 'The kit is complete. Use add_bundle_to_cart, or tell the shopper to go back a step in the wizard.',
        state,
      };
    }

    const step = currentSteps[currentStepIndex];
    if (!step || String(step.key) !== String(stepKey)) {
      return {
        error: `Current step is "${step?.key || 'none'}", not "${stepKey}". Call get_bundle_state and use currentStep.key.`,
        state,
      };
    }

    const option = getVisibleOptionsForStep(step).find((item) => String(item?.id) === String(optionId));
    if (!option) {
      return { error: `No option "${optionId}" on the current step. Use an id from currentStep.options.`, state };
    }
    if (isUnavailableOption(option)) {
      return { error: 'That option is sold out and cannot be selected.', state };
    }

    if (isOtherStep(step)) {
      toggleOtherOption(stepKey, optionId);
      return { ok: true, state: getState() };
    }

    selectStepOption(stepKey, optionId);
    return { ok: true, state: getState() };
  }

  function skipCurrentStep(stepKey, confirmIncomplete = false) {
    const state = getState();
    if (state.phase === 'needs_vehicle') {
      return { error: 'No vehicle selected. Use set_shopper_vehicle first.', state };
    }
    if (state.phase === 'no_bundle' || state.isBuildComplete) {
      return { error: 'There is no current kit step to skip.', state };
    }

    const step = currentSteps[currentStepIndex];
    if (!step || String(step.key) !== String(stepKey)) {
      return {
        error: `Current step is "${step?.key || 'none'}", not "${stepKey}". Call get_bundle_state and use currentStep.key.`,
        state,
      };
    }
    if (!canSkipStep(stepKey)) {
      return { error: `The "${stepKey}" step cannot be skipped.`, state };
    }

    if (SKIP_WARNING_STEP_KEYS.has(stepKey) && !confirmIncomplete) {
      requestSkipStep(stepKey);
      const copy = SKIP_WARNING_COPY[stepKey];
      return {
        needsConfirmation: true,
        warning: copy
          ? copy.message(formatSelectedVehicleLabel(window.TdVehicleStorage?.getSelectedVehicle()))
          : 'Skipping this step makes an incomplete delete kit.',
        message: 'Call skip_bundle_step again with confirm_incomplete true if the shopper still wants to skip.',
        state: getState(),
      };
    }

    pendingSkipStepKey = null;
    closeSkipWarningModal();
    skipStep(stepKey);
    return { ok: true, needsConfirmation: false, state: getState() };
  }

  async function addCurrentBuildToCart() {
    const state = getState();

    if (!canAddBuildToCart()) {
      return {
        error: 'Nothing to add. Choose at least one kit part, then try again.',
        state,
      };
    }

    const result = await addBuildToCart();
    const soldOutLabels = getSoldOutNoticeLabels(result.droppedItems);

    if (!result.ok) {
      return {
        error: soldOutLabels.length
          ? `Nothing was added. These parts are sold out: ${soldOutLabels.join(', ')}. Have the shopper pick available options.`
          : 'Unable to add the kit to the cart. Please try again.',
        soldOutItems: soldOutLabels,
        state: getState(),
      };
    }

    const soldOutNote = soldOutLabels.length
      ? ` These parts were sold out and left out of the cart: ${soldOutLabels.join(', ')}.`
      : '';
    const discountNote = result.discountApplied
      ? `with ${BUNDLE_DISCOUNT_PERCENT}% off (${BUNDLE_DISCOUNT_CODE})`
      : 'without CUSTOM_BUNDLE, because the items added do not cover tuner, EGR, and exhaust';

    return {
      ok: true,
      addedItems: serializeBuildItems(result.addedItems),
      soldOutItems: soldOutLabels,
      discountApplied: result.discountApplied,
      discountCode: result.discountApplied ? BUNDLE_DISCOUNT_CODE : null,
      message: `Kit added to cart ${discountNote}.${soldOutNote}`,
      state: getState(),
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleBuilder);
  } else {
    initBundleBuilder();
  }

  window.TdBundleBuilder = {
    VEHICLE_METAOBJECT_MAP,
    resolveVehicleConfig,
    getMetaobjectData,
    getMetaobjectsByHandle,
    buildStepsWithNotes,
    getVisibleStateIds,
    updateStateContainer,
    startBundleSteps,
    renderCurrentStep,
    getTempCartItems,
    renderTempCart,
    clearTempCart,
    addBuildToCart,
    getState,
    chooseOption,
    skipCurrentStep,
    addCurrentBuildToCart,
  };
})();
